import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import CountdownSection from './components/CountdownSection';
import BenefitsSection from './components/BenefitsSection';
import ExpansionMapSection from './components/ExpansionMapSection';
import WaitlistSection from './components/WaitlistSection';
import TestimonialsSection from './components/TestimonialsSection';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      {/* Header Navigation */}
      <Header />
      
      <main className="relative z-10">
        {/* Hero Section - Bold Introduction */}
        <HeroSection />
        
        {/* Countdown Section - Urgency for First 1000 */}
        <CountdownSection />
        
        {/* Benefits Section - Founding Member Perks */}
        <BenefitsSection />
        
        {/* Expansion Map - Geographic Focus */}
        <ExpansionMapSection />
        
        {/* Waitlist Registration - Primary CTA */}
        <WaitlistSection />
        
        {/* Social Proof - Testimonials */}
        <TestimonialsSection />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;